<template>
  <div class="mb-2 border rounded-md">
    <div class="p-3 flex gap-6 items center">
      <span>
        {{ category }}
      </span>
      <div class="flex gap-3 justify-evenly">
        <div class="flex gap-2" v-for="(item, key) in items" :key="key">
          <label :for="'lang-' + key">{{ key }}</label>
          <input
            :id="'lang-' + key"
            type="radio"
            :name="folderItem.parentFolder + '-' + category + '-language'"
            :value="key"
            v-model="language"
          />
        </div>
      </div>
    </div>
    <ul class="ml-8 pr-8" v-if="language.length">
      <li
        v-for="item in items[language]"
        :key="item.Guid"
        class="py-2 list-disc break-all"
      >
        <a class="text-blue-500 underline" :href="item.Url">
          {{ item.Name.length ? item.Name : item.Url }}
        </a>
        <br />
        <span v-if="item.Description.length" class="text-sm"
          ><b>Description:</b> {{ item.Description }}</span
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { ref, reactive } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";

export default {
  name: "FolderContentItem",
  props: {
    category: {
      type: String,
      required: true,
    },
    folderItem: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const language = ref("");
    const items = reactive({ ...props.folderItem });

    onMounted(() => {
      delete items.parentFolder;
    });

    return {
      items,
      language,
    };
  },
};
</script>

<style></style>
